import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { employerRequestAPI } from '../services/api';
import toast from 'react-hot-toast';

const EmployerRequestForm = () => {
  const { requestId } = useParams();
  const navigate = useNavigate();
  const [additionalInfo, setAdditionalInfo] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [requestInfo, setRequestInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // You can fetch request info to show company name, etc.
    // For now, we'll just show the form
    setLoading(false);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!requestId) {
      toast.error('Invalid request ID');
      return;
    }

    setSubmitting(true);
    try {
      const response = await employerRequestAPI.submitForm(requestId, additionalInfo);
      
      if (response.data.success) {
        toast.success('Form submitted successfully! Your request is now under review.');
        setTimeout(() => {
          navigate('/');
        }, 2000);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error(error.response?.data?.detail || 'Failed to submit form. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center">
        <div className="spinner h-12 w-12"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-surface py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto">
        <div className="auth-card">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Complete Your Employer Access Request
            </h1>
            <p className="text-gray-600">
              Please provide additional information about your company to help us process your request.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="additionalInfo" className="block text-sm font-medium text-gray-700 mb-2">
                Additional Information
              </label>
              <textarea
                id="additionalInfo"
                value={additionalInfo}
                onChange={(e) => setAdditionalInfo(e.target.value)}
                rows={8}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent resize-none"
                placeholder="Please provide any additional information about your company, hiring needs, expected number of positions, timeline, or any other relevant details..."
                required
              />
              <p className="mt-2 text-sm text-gray-500">
                This information will help us better understand your requirements and process your request faster.
              </p>
            </div>

            <div className="flex items-center justify-between pt-4">
              <button
                type="button"
                onClick={() => navigate('/')}
                className="px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={submitting || !additionalInfo.trim()}
                className="px-6 py-3 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {submitting ? 'Submitting...' : 'Submit Form'}
              </button>
            </div>
          </form>

          <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-sm text-blue-800">
              <strong>Note:</strong> After submitting this form, your request will be reviewed by our team. 
              You will receive an email notification once your request has been processed.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployerRequestForm;



